export default Object.freeze({
    WATER: [
        'sampleComment',
        'labId',
        'type',
        'samples',
        'networkType',
        'componentType',
        'collectedDate',
        'receivedDate',
        'treatment',
        'applicableNorms',
        'analyses',
    ],

    RESIN: [
        'sampleComment',
        'labId',
        'type',
        'samples',
        'networkType',
        'componentType',
        'collectedDate',
        'receivedDate',
        'treatment',
        'applicableNorms',
        'analyses',
    ],

    OTHER: [
        'sampleComment',
        'labId',
        'type',
        'samples',
        'networkType',
        'componentType',
        'collectedDate',
        'receivedDate',
        'treatment',
        'applicableNorms',
        'analyses',
    ],

    LEGIONELLOSIS: [
        'sampleComment',
        'labId',
        'type',
        'samples',
        'networkType',
        'componentType',
        'collectedDate',
        'receivedDate',
        'treatment',
        'plating',
        'applicableNorms',
        'resultInterpretation',
        'analyses',
    ],

    LEGIONELL_CULTURE: [
        'sampleComment',
        'labId',
        'type',
        'samples',
        'networkType',
        'componentType',
        'collectedDate',
        'receivedDate',
        'treatment',
        'plating',
        'applicableNorms',
        'treatmentUsed',
        'expressionResult',
        'resultInterpretation',
        'analyses',
    ],
    CONTENANCE: [
        'sampleComment',
        'labId',
        'type',
        'samples',
        'networkType',
        'componentType',
        'collectedDate',
        'receivedDate',
        'treatment',
        'addedLithium',
        'addedTracer',
        'estimatedVolume',
        'initialTracerConcentration',
        'collectionLossDate',
        'tracerAddedDate',
        'activeTracerQuantity',
        'finalTracerConcentration',
        'blankConcentration',
        'systemVolumeImp',
        'systemVolumeUsg',
        'systemVolumeLiter',
        'timePeriodForWaterLosses',
        'waterLossRate',
        'waterLossTotal',
    ],
    DEPOSIT: [
        'sampleComment',
        'labId',
        'samples',
        'receivedDate',
        'treatment',
        'networkType',
        'componentType',
        'otherTreatment',
        'estimatedDepositAge',
        'application',
        'materialType',
        'waterType',
        'incidents',
        'appearance',
        'depositComposition',
        'mineralPhases',
        'organicMaterial',
        'totalIdentifiedPhases',
        'depositPicture',
    ],
    COUPON: [
        'sampleComment',
        'labId',
        'identification',
        'coupon',
        'code',
        'componentType',
        'collectedBy',
        'installedDate',
        'collectedDate',
        'receivedDate',
        'treatment',
        'applicableNorms',
        'daysInstalled',
        'initialWeight',
        'finalWeight',
        'surface',
        'density',
        'weightLost',
        'corrosionRate',
        'pictureBeforeCleaning',
        'pictureAfterCleaning',
    ],
    GLYCOL: ['sampleComment', 'labId', 'type', 'samples', 'networkType', 'componentType', 'collectedDate', 'receivedDate', 'glycolType', 'treatment', 'applicableNorms', 'analyses'],
});
